import BlockIcon from '@mui/icons-material/Block';
import { Tooltip, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class VotoNaoLiberado extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            disponivel: computed
        });
    }

    get configIcone() {
        return {
            cor: red[900],
            opacidade: 0.7,
            texto: 'Voto não liberado pelo relator'
        };
    }

    get disponivel() {
        return this.store.descricaoProcessosEmExibicao === 'disponíveis';
    }

    render() {
        if (!this.observableProps.registro || this.observableProps.registro.liberadoPeloRelator || this.disponivel) {
            return null;
        }

        return (
            <Tooltip title={<Typography>{this.configIcone.texto}</Typography>}>
                <BlockIcon
                    sx={{
                        color: this.configIcone.cor,
                        fillOpacity: this.configIcone.opacidade,
                        cursor: 'default'
                    }}
                />
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(VotoNaoLiberado));
